import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getChatActive } from "../../ducks/chat/selectors";
import { setChatActive } from "../../ducks/chat/chat";

export const useChatActive = (): [boolean, (value: boolean) => void] => {
  const dispatch = useDispatch();
  const chatActive = useSelector(getChatActive);

  const update = useCallback(
    (value: boolean) => {
      dispatch(setChatActive(value));
    },
    [dispatch],
  );

  return [chatActive, update];
};
